<template>
  <ranking-page
    endpoint="/spontan/ranking/total/points"
    heading-danish="Rangliste - Point i alt"
    heading-english="Ranking - Total points"
  />
</template>

<script>
import RankingPage from "./RankingPage.vue";

export default {
  components: { RankingPage },
};
</script>
